module.exports = "<ul>\n  <ng-content></ng-content>\n</ul>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/tooltip-button-dropdown/tooltip-button-dropdown.component.html
// module id = ../../../../../src/app/shared/components/tooltip-button-dropdown/tooltip-button-dropdown.component.html
// module chunks = 12